function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (config, continueBtnText, doneText, hasNarration, hasPrompt, i18n, playinline, prompt, submitUp, tappies, title, videoExtension) {
      pug_mixins["video-stream"] = pug_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
videoUrl = videoUrl ? `${videoUrl}#t=0.01` : '' // this is a hack to show thumbnail in iOS
videoExtension = videoUrl ? videoUrl.split(/[#?]/)[0].split('.').pop().trim() : ''
pug_html = pug_html + "\u003Cvideo" + (pug_attr("class", pug_classes(["video-js",klass], [false,true]), false, true)+pug_attr("playsinline", playsinline, true, true)+pug_attr("controls", controls, true, true)+" preload=\"auto\""+pug_attr("dir", config.direction, true, true)+pug_attr("poster", poster, true, true)) + "\u003E\u003Csource" + (pug_attr("src", videoUrl, true, true)+pug_attr("type", `video/${videoExtension}`, true, true)) + "\u003E\u003C\u002Fvideo\u003E";
};
pug_mixins["media-collection-content"] = pug_interp = function(prop, obj, isDetails){
var block = (this && this.block), attributes = (this && this.attributes) || {};
obj = obj || locals;
switch (obj[prop + "Type"]){
case "image":
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes(["block-v-md",isDetails ? "full-size" : "thumbnail"], [false,true]), false, true)+pug_attr("src", obj[prop], true, true)) + "\u003E";
  break;
case "audio":
if (isDetails) {
pug_html = pug_html + "\u003Caudio" + (" class=\"multi-content multi-content-audio full-size\""+pug_attr("src", obj[prop], true, true)+pug_attr("webkit-playsinline", true, true, true)+pug_attr("playsinline", true, true, true)+" preload=\"auto\""+pug_attr("controls", true, true, true)) + "\u003E\u003C\u002Faudio\u003E";
}
else {
pug_html = pug_html + "\u003Caudio" + (" class=\"multi-content multi-content-audio thumbnail\""+pug_attr("src", obj[prop], true, true)+pug_attr("webkit-playsinline", true, true, true)+pug_attr("playsinline", true, true, true)+" preload=\"none\""+pug_attr("controls", true, true, true)) + "\u003E\u003C\u002Faudio\u003E";
}
  break;
case "video":
default:
if (isDetails) {
pug_mixins["video-stream"](obj[prop], true, true, "multi-content vjs-fluid full-size");
}
else {
pug_mixins["video-stream"](obj[prop], false, false, "video vjs-fluid multi-content thumbnail");
}
  break;
}
};
pug_html = pug_html + "\u003Cdiv class=\"block-v-lg content-fill text-center\"\u003E\u003Cdiv class=\"content-container content-fill\"\u003E\u003Cdiv class=\"content-sm-ver content-md-ver content-lg-ver\"\u003E\u003Ch1 class=\"title slide-down delay-3 tight\"\u003E" + (null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003Cdiv class=\"parent-container content-fill\"\u003E\u003Cdiv class=\"tappies-parent content-fill\"\u003E\u003Cdiv class=\"row tappies text-center\"\u003E";
if (!!tappies) {
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var tappy = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["tappy","content-fill","col-sm-12","col-lg-8","col-lg-offset-2","slide-up",`delay-${i}`], [false,false,false,false,false,false,true]), false, true)+pug_attr("data-index", i, true, true)) + "\u003E\u003Cdiv class=\"tappy-child content-fill block-dk block-sm\"\u003E";
pug_mixins["media-collection-content"]("content", tappy, false);
pug_html = pug_html + "\u003C!-- put a transparent overlay on top of each item that--\u003E\u003C!-- intercepts the click\u002Ftap events--\u003E\u003Cdiv class=\"tappy-overlay\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var tappy = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["tappy","content-fill","col-sm-12","col-lg-8","col-lg-offset-2","slide-up",`delay-${i}`], [false,false,false,false,false,false,true]), false, true)+pug_attr("data-index", i, true, true)) + "\u003E\u003Cdiv class=\"tappy-child content-fill block-dk block-sm\"\u003E";
pug_mixins["media-collection-content"]("content", tappy, false);
pug_html = pug_html + "\u003C!-- put a transparent overlay on top of each item that--\u003E\u003C!-- intercepts the click\u002Ftap events--\u003E\u003Cdiv class=\"tappy-overlay\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"details-parent content-fill\"\u003E";
if (!!tappies) {
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var tappy = $$obj[i];
pug_html = pug_html + "\u003Cdiv class=\"details content-sm-ver content-md-ver content-lg-ver\"\u003E";
pug_mixins["media-collection-content"]("content", tappy, true);
pug_html = pug_html + "\u003Cdiv class=\"caption block-v-md block-h-md text-md\"\u003E" + (null == (pug_interp = tappy.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var tappy = $$obj[i];
pug_html = pug_html + "\u003Cdiv class=\"details content-sm-ver content-md-ver content-lg-ver\"\u003E";
pug_mixins["media-collection-content"]("content", tappy, true);
pug_html = pug_html + "\u003Cdiv class=\"caption block-v-md block-h-md text-md\"\u003E" + (null == (pug_interp = tappy.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-footer","block-v-lg",submitUp ? "slide-footer--up slide-down" : "slide-up"], [false,false,true]), false, true)) + "\u003E";
if (hasPrompt) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-touched\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis\" id=\"done-btn\"\u003E" + (null == (pug_interp = doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (typeof prompt === "string") {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt text-uppercase text-bold\"\u003E\u003Cdiv class=\"slide-footer-prompt-content content-ver\" id=\"prompt\"\u003E" + (null == (pug_interp = prompt) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis content-ver\" id=\"prompt-btn\"\u003E" + (null == (pug_interp = continueBtnText || doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
if (hasNarration) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-narration\"\u003E\u003Cdiv class=\"narration-progress btn btn-muted\"\u003E\u003Cdiv class=\"narration-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wave-ellipse\"\u003E\u003Cspan class=\"bullet delay-1 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-2 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-3 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "config" in locals_for_with ?
        locals_for_with.config :
        typeof config !== 'undefined' ? config : undefined, "continueBtnText" in locals_for_with ?
        locals_for_with.continueBtnText :
        typeof continueBtnText !== 'undefined' ? continueBtnText : undefined, "doneText" in locals_for_with ?
        locals_for_with.doneText :
        typeof doneText !== 'undefined' ? doneText : undefined, "hasNarration" in locals_for_with ?
        locals_for_with.hasNarration :
        typeof hasNarration !== 'undefined' ? hasNarration : undefined, "hasPrompt" in locals_for_with ?
        locals_for_with.hasPrompt :
        typeof hasPrompt !== 'undefined' ? hasPrompt : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "playinline" in locals_for_with ?
        locals_for_with.playinline :
        typeof playinline !== 'undefined' ? playinline : undefined, "prompt" in locals_for_with ?
        locals_for_with.prompt :
        typeof prompt !== 'undefined' ? prompt : undefined, "submitUp" in locals_for_with ?
        locals_for_with.submitUp :
        typeof submitUp !== 'undefined' ? submitUp : undefined, "tappies" in locals_for_with ?
        locals_for_with.tappies :
        typeof tappies !== 'undefined' ? tappies : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "videoExtension" in locals_for_with ?
        locals_for_with.videoExtension :
        typeof videoExtension !== 'undefined' ? videoExtension : undefined));
    ;;return pug_html;};module.exports=template;